/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspayoutnone2Inputs */

const en_earningspayoutnone2 = /** @type {(inputs: Earningspayoutnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to pay out`)
};

const de_earningspayoutnone2 = /** @type {(inputs: Earningspayoutnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts auszuzahlen`)
};

/**
* | output |
* | --- |
* | "Nothing to pay out" |
*
* @param {Earningspayoutnone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayoutnone2 = /** @type {((inputs?: Earningspayoutnone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayoutnone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayoutnone2(inputs)
	return de_earningspayoutnone2(inputs)
});
export { earningspayoutnone2 as "earningsPayoutNone" }